"use client"

// src/tokens/line-heights.ts
var lineHeights = {
  base: 1.5,
  normal: "normal",
  shorter: 1.25,
  short: 1.375,
  tall: 1.625,
  taller: 2,
  none: 1,
  "3": ".75rem",
  "4": "1rem",
  "5": "1.25rem",
  "6": "1.5rem",
  "7": "1.75rem",
  "8": "2rem",
  "9": "2.25rem",
  "10": "2.5rem"
};

export {
  lineHeights
};
//# sourceMappingURL=chunk-7R772KLP.mjs.map